import { indexedDbStorage } from "@/helpers/indexedDB";

export default {
  namespaced: true,
  state() {
    return {
      aiEnabled: false,
      currentSnapshot: null,
      imagesLibrary: [],
      showAiDialog: false,
      showAiSnappingDialog: false,
      showAiImagesLibrary: false,
      previewingImage: null,
      aiSnapshotProcess: false,
      showAiReady: false,
      aiProcessing: false,
      imageFromGallery: null,
    };
  },
  mutations: {
    showAiDialog(state, showAiDialog) {
      state.showAiDialog = showAiDialog;
    },
    showAiSnappingDialog(state, showAiSnappingDialog) {
      state.showAiSnappingDialog = showAiSnappingDialog;
    },
    showAiImagesLibrary(state, showAiImagesLibrary) {
      state.showAiImagesLibrary = showAiImagesLibrary;
    },
    currentSnapshot(state, currentSnapshot) {
      state.currentSnapshot = currentSnapshot;
    },
    addToImagesLibrary(state, image) {
      if(!image.startsWith('data:image/png;base64,')){
        image = 'data:image/png;base64,' + image
      }
      state.imagesLibrary.push(image);
    },
    removeFromImagesLibrary(state, index) {
      state.imagesLibrary.splice(index, 1);
    },
    imagesLibrary(state, imagesLibrary) {
      state.imagesLibrary = imagesLibrary;
    },
    previewingImage(state, previewingImage) {
      if(typeof(previewingImage) === 'string' && !previewingImage.startsWith('data:image/png;base64,')){
        previewingImage = 'data:image/png;base64,' + previewingImage
      }
      state.previewingImage = previewingImage;
    },
    aiSnapshotProcess(state, aiSnapshotProcess) {
      state.aiSnapshotProcess = aiSnapshotProcess;
    },
    showAiReady(state, showAiReady) {
      state.showAiReady = showAiReady;
    },
    aiProcessing(state, aiProcessing) {
      state.aiProcessing = aiProcessing;
    },
    imageFromGallery(state, imageFromGallery) {
      state.imageFromGallery = imageFromGallery;
    },
    aiEnabled(state, aiEnabled) {
      state.aiEnabled = aiEnabled;
    },
  },
  actions: {
    async init({ commit }) {
      let images = await indexedDbStorage.getItem("aIAgent_imagesLibrary");
      
      // Migration from localStorage
      if (!images) {
        try {
          const localImages = localStorage.getItem("aIAgent_imagesLibrary");
          if (localImages) {
            images = JSON.parse(localImages);
            if (images && Array.isArray(images)) {
              await indexedDbStorage.setItem("aIAgent_imagesLibrary", images);
              localStorage.removeItem("aIAgent_imagesLibrary");
            }
          }
        } catch (e) {
          console.warn("aIAgent_imagesLibrary migration error", e);
        }
      }

      if (images) {
        commit('imagesLibrary', images);
      }
    },
    async addToImagesLibrary({ commit, state }, image) {
      commit('addToImagesLibrary', image);
      await indexedDbStorage.setItem("aIAgent_imagesLibrary", [...state.imagesLibrary]);
    },
    async removeFromImagesLibrary({ commit, state }, index) {
      commit('removeFromImagesLibrary', index);
      await indexedDbStorage.setItem("aIAgent_imagesLibrary", [...state.imagesLibrary]);
    },
    async imagesLibrary({ commit }, imagesLibrary) {
      commit('imagesLibrary', imagesLibrary);
      await indexedDbStorage.setItem("aIAgent_imagesLibrary", imagesLibrary);
    }
  },
  getters: {
    imagesLibrary({ imagesLibrary }) {
      return imagesLibrary;
    },
    currentSnapshot({ currentSnapshot }) {
      return currentSnapshot;
    },
    showAiDialog({ showAiDialog }) {
      return showAiDialog;
    },
    showAiSnappingDialog({ showAiSnappingDialog }) {
      return showAiSnappingDialog;
    },
    showAiImagesLibrary({ showAiImagesLibrary }) {
      return showAiImagesLibrary;
    },
    previewingImage({ previewingImage }) {
      return previewingImage;
    },
    aiSnapshotProcess({ aiSnapshotProcess }) {
      return aiSnapshotProcess;
    },
    showAiReady({ showAiReady }) {
      return showAiReady;
    },
    aiProcessing({ aiProcessing }) {
      return aiProcessing;
    },
    imageFromGallery({ imageFromGallery }) {
      return imageFromGallery;
    },
    aiEnabled({ aiEnabled }) {
      return aiEnabled;
    },
  },
};
